import { defineMessages } from 'react-intl';

export default defineMessages({
  noResultsHeading: {
    id: 'frontbucket.search.sourceBrowser.noResultsHeading',
    description: 'Source browser no search results heading',
    defaultMessage: `We couldn't find what you're looking for in this repository`,
  },
  noResultsDescription: {
    id: 'frontbucket.search.sourceBrowser.noResultsDescription',
    description: 'Source browser search results info message header',
    defaultMessage:
      'Try using a different search term, or view search results {codeSearchLink}',
  },
  noResultsCodeSearchLinkLabel: {
    id: 'frontbucket.search.sourceBrowser.noResultsCodeSearchLinkLabel',
    description:
      'Source browser search results advanced code search link label',
    defaultMessage: 'outside of this repository.',
  },
});
